<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <section id="hero" class="screen" ref="heroElement">
        <img class="background" src="@/assets/photos/landscape-blur-3200.jpg" srcset="@/assets/photos/landscape-blur-3200.jpg 3200w,
            @/assets/photos/landscape-blur-2400.jpg 2400w,
            @/assets/photos/landscape-blur-1600.jpg 1600w,
            @/assets/photos/landscape-blur-1200.jpg 1200w,
            @/assets/photos/landscape-blur-800.jpg 800w" />
        <div class="content back-blur">
            <div class="center" ref="contentElement">
                <img src="@/assets/onlyoneprod-logo.svg" alt="Only One Prod" class="logo" />
                <slot />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const heroElement = ref<HTMLElement>();
const contentElement = ref<HTMLElement>();

onMounted(() => {
    if (!heroElement.value || !contentElement.value) {
        return;
    }

    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && contentElement.value) {
            contentElement.value.classList.add('show');
        }
    });
    observer.observe(heroElement.value);
});
</script>

<style lang="sass" scoped>
.center
    @apply opacity-0 transition duration-700 ease-in-out delay-500

    &.show
        @apply opacity-100
</style>